// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".detail-header[data-v-7df906ed] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n}\n.information[data-v-7df906ed] {\n  width: 100%;\n}\n.total-text[data-v-7df906ed] {\n  font-weight: bold;\n  font-size: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
